module.exports = __webpack_public_path__ + "static/img/jinian@2x.bd3dd77a.png";